export default __webpack_public_path__ + "static/media/piano.7d499b0d.png";